// TODO: Import React module
import { useContext, useEffect } from 'react';

// TODO: Import MUI module
import { Divider, Typography } from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';
import { MultipleRows } from '../Common/TypographyTYH';
import TabInfo from './TabInfo';

import Slide from './Slide.jpg';

const PTA = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component PTA Rendered');

    // TODO: Define useContext
    const { language } = useContext(Context);

    // TODO: Define variable

    // TODO: Define event
    useEffect(() => { window.scrollTo(0, 0); }, []);

    // TODO: Return component
    return (
        <BoxSubPage
            id="PTA"
            image={Slide}
            disableMenu={true}
            disableSubtitle={true}
            title={Text.PTA.Title[language]}
        >
            <MultipleRows rows={Text.PTA.Intro[language]} />
            {/*<Typography sx={{ color: 'black', mt: 2 }} variant="body1">
                {Text.PTA.CommitteeTitle[language]}
            </Typography>*/}
            <Typography sx={{ mb: 2 }} variant="body1">
                以下為第二十四屆家教會常務委員會:
            </Typography>
            <Typography variant="body1">
                李頴佳先生、盧子健先生、盧頴詩女士、李繼兒女士、阮嘉欣女士、楊崎珍女士、黃慧儀女士、林佩瑩女士、李惠蓮副校長、潘錦偉副校長、張俊晗老師、蔡睿溱老師、羅凱玲老師、林嘉俊老師、何卓橋老師
            </Typography>
            {/*<ul>
                <li>主席: 李頴佳先生</li>
                <li>副主席: 蔡睿溱老師、盧子健先生</li>
                <li>秘書: 李惠蓮副校長、羅凱玲老師</li>
                <li>司庫: 林嘉俊老師、阮嘉欣女士</li>
                <li>聯絡: 陳國帆先生、陳冠全副校長、林佩瑩女士、盧頴詩女士、潘錦偉副校長</li>
                <li>康樂: 李國威助理校長、楊崎珍女士</li>
                <li>出版: 張俊晗老師、李繼兒女士</li>
            </ul><Typography variant="body1">
                如各家長對是次執行委員會委員選舉結果有任何查詢或異議，可在選舉結果公佈後的一星期內(即11月12日下午5時正前)向學校提出。
            </Typography>*/}
            <Divider sx={{ my: 2 }} />
            <TabInfo />
        </BoxSubPage>
    );
};
export default PTA;